import { Component } from "react";

export class PanelErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Panel crashed:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center py-16 gap-3 text-center" data-testid="panel-error-fallback">
          <div className="text-3xl">😕</div>
          <div className="text-sm text-gray-600">{this.props.message || "Something went wrong"}</div>
          <button
            data-testid="panel-error-reload-btn"
            onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            className="px-4 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800">
            {this.props.reloadLabel || "Reload"}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
